import React from 'react'
import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { integrationToName } from 'components/IntegrationRequiredModal/IntegrationRequiredModal'
import { StackModalProps } from 'almanac-ui/Modal/Types'

interface SwitchAccountConfirmationModalProps extends StackModalProps {
  integration: ExternalIntegration
  onConfirm: () => void
}

export const SwitchAccountConfirmationModal = ({
  integration,
  onConfirm,
  close,
}: SwitchAccountConfirmationModalProps) => {
  const platformName = integrationToName[integration.provider]

  const handleConfirm = () => {
    close()
    onConfirm()
  }

  return (
    <Modal.Root size="sm" onPressOutside={close}>
      <Modal.Header title="Your posts will be rescheduled to the new account." />
      <Modal.Content>
        <Text>Blaze will now post all {platformName} content to the new account. Do you want to continue?</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={close}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" variant="primary" onPress={handleConfirm}>
            Reschedule All to New Account
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
